import { IProps } from './index'

const Nonin8500 = ({ onCancel }: IProps) => {
  return (
    <div
      className="reader-view"
      data-reader-view="device-instructions"
      data-device-type="n8500"
    >
      <h3 className="mb-6">
        <i className="fa fa-info-circle"></i>
        Instructions for clearing the oximeter's memory
      </h3>
      <ul className="text-left">
        <li>
          <span>1</span> Press the <kbd>&#x2503;</kbd> and <kbd>&#x2B06;</kbd>{' '}
          buttons to enter SETUP mode
        </li>
        <li>
          The display should now read{' '}
          <samp>
            Clr
            <br />
            no
          </samp>
        </li>
        <li>
          <span>2</span> Press the <kbd>&#x2B06;</kbd> button to set the value
          to <samp>YES</samp>
        </li>
        <li>
          <span>3</span> Press the <kbd>&#x2503;</kbd> button to advance to the
          next setting
        </li>
        <li>
          The display should now read{' '}
          <samp>
            dEL
            <br />
            no
          </samp>
        </li>
        <li>
          <span>4</span> Press the <kbd>&#x2B06;</kbd> button to set the value
          to <samp>YES</samp>
        </li>
        <li>
          <span>5</span> Press the <kbd>&#x2503;</kbd> button to clear the
          memory
        </li>
        <li>
          The display should now read{' '}
          <samp>
            &mdash;
            <br />
            &mdash;
          </samp>
        </li>
        <li>
          <span>6</span> Press and hold the <kbd>&#x2503;</kbd> button to turn
          the device off
        </li>
      </ul>
      <p>&nbsp;</p>
      <h3 className="mb-6">
        <i className="fa fa-info-circle"></i> Instructions for setting the
        oximeter's date and time
      </h3>
      <ul className="text-left">
        <li>
          <span>1</span> Press the <kbd>&#x2503;</kbd> and <kbd>&#x2B06;</kbd>{' '}
          buttons to enter SETUP mode
        </li>
        <li>
          The display should now read{' '}
          <samp>
            Clr
            <br />
            no
          </samp>
        </li>
        <li>
          <span>2</span> IF NOT, press the <kbd>&#x2B06;</kbd> button to set the
          value to <samp>no</samp>
        </li>
        <li>
          <span>3</span> Press the <kbd>&#x2503;</kbd> button to advance to the
          next setting
        </li>
        <li>
          The display should now read <samp>y</samp>
        </li>
        <li>
          IF NOT, press the <kbd>&#x2503;</kbd> button to advance to the next
          setting until it does
        </li>
        <li>
          <span>4</span> Press the <kbd>&#x2B06;</kbd> to set the current year:{' '}
          <samp>date('y')</samp>
        </li>
        <li>
          <span>5</span> Press the <kbd>&#x2503;</kbd> button to advance to the
          next setting
        </li>
        <li>
          The display should now read <samp>nn</samp>
        </li>
        <li>
          <span>6</span> Press the <kbd>&#x2B06;</kbd> to set the current month:{' '}
          <samp>date('m')</samp>
        </li>
        <li>
          <span>7</span> Press the <kbd>&#x2503;</kbd> button to advance to the
          next setting
        </li>
        <li>
          The display should now read <samp>d</samp>
        </li>
        <li>
          <span>8</span> Press the <kbd>&#x2B06;</kbd> to set the current day:{' '}
          <samp>date('d')</samp>
        </li>
        <li>
          <span>9</span> Press the <kbd>&#x2503;</kbd> button to advance to the
          next setting
        </li>
        <li>
          The display should now read <samp>h</samp>
        </li>
        <li>
          <span>10</span> Press the <kbd>&#x2B06;</kbd> to set the current hour:{' '}
          <samp>date('H')</samp>
        </li>
        <li>
          <span>11</span> Press the <kbd>&#x2503;</kbd> button to advance to the
          next setting
        </li>
        <li>
          The display should now read <samp>nn</samp>
        </li>
        <li>
          <span>12</span> Press the <kbd>&#x2B06;</kbd> to set the current
          minute: <samp>date('i')</samp>
        </li>
        <li>
          <span>13</span> Press the <kbd>&#x2503;</kbd> button to advance to the
          next setting
        </li>
        <li>
          The display should now read{' '}
          <samp>
            &mdash;
            <br />
            &mdash;
          </samp>
        </li>
        <li>
          <span>14</span> Press and hold the <kbd>&#x2503;</kbd> button to turn
          the device off
        </li>
      </ul>
      <div className="flex justify-center items-center space-x-2 my-6">
        <button className="btn btn-default" onClick={onCancel}>
          <i className="fa fa-reply"></i>
          Reset Another Device
        </button>
      </div>
    </div>
  )
}

export default Nonin8500
